import { render, staticRenderFns } from "./student_request_edit.vue?vue&type=template&id=abdc59a6&scoped=true&"
import script from "./student_request_edit.vue?vue&type=script&lang=js&"
export * from "./student_request_edit.vue?vue&type=script&lang=js&"
import style0 from "./student_request_edit.vue?vue&type=style&index=0&id=abdc59a6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdc59a6",
  null
  
)

export default component.exports